<template>
  <div>
    {{ label }}
    <span v-show="!loading">
      {{ formatResult(originalValue) }}
    </span>
    <span
      class="text-success d-none"
      :class="{ 'd-inline-block': modified }"
    >
      ( {{ correctValue }} )
    </span>
    <b-spinner
      v-show="loading"
      class="spinner-border-sm"
      variant="success"
      label="Spinning"
    />
  </div>
</template>

<script>
  export default {
    name: 'BaseListItem',
    mixins: [],
    props: {
      label: {
        type: String,
        default: '',
      },
      loading: {
        type: Boolean,
        default: false,
      },
      formatResult: {
        type: Function,
        default: value => value,
      },
      modified: {
        type: Boolean,
        default: false,
      },
      originalValue: {
        type: [String, Number],
        default: '',
      },
      correctValue: {
        type: [String, Number],
        default: '',
      },
    },
    data() {
      return {};
    },
    methods: {},
  };
</script>
